import Vue from 'vue';
import App from './App.vue';
import ElementUI, { Notification } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from '@/router/index.js';
import axios from '@/utils/request.js';
import pinia, { PiniaPlugin as PiniaVuePlugin } from '@/pinia/index.js';
import VueCookies from 'vue-cookies';
import VCharts from 'v-charts';
import { useRoleAuths, useDeptAuths} from '@/hooks/roleAuths';
import '@/styles/index.scss';
import '@/utils/setIcon';
import '@/utils/setWindow';
import '@/directives';

import Fingerprint2 from 'fingerprintjs2';
import VueClipboard from 'vue-clipboard2';
import VueClipboards from 'vue-clipboards';
import Contextmenu from "vue-contextmenujs";

// # 2024.09.23，使用天地图渲染电子地图
// 高德地图
// import VueAMap, { initAMapApiLoader, lazyAMapApiLoaderInstance } from '@vuemap/vue-amap';
// import '@vuemap/vue-amap/dist/style.css';
// initAMapApiLoader({
//   key: '2be387ce327a87e1ac669bc3f9bf08e9',
//   securityJsCode: 'b894a59af7474ab88c04c434599f7b0a',
//   version: '2.0',
//   // plugins: [],
// });
// Vue.use(VueAMap);
// lazyAMapApiLoaderInstance.then(() => {
//   console.log('map load success');
//   window.mapLoaded = true;
// }).catch(() => {
//   console.log('map load fail');
//   window.mapLoaded = false;
// });


Vue.config.productionTip = false;

/**
 * 通过设备浏览器信息获取浏览器指纹
 * 生成一个用户设备的浏览器的唯一ID
 */
Fingerprint2.get(function (components) {
  const values = components.map(function (component, index) {
    if (index === 0) {  // 把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
      return component.value.replace(/\bNetType\/\w+\b/, '');
    }
    return component.value;
  })
  // 生成最终id
  let port = window.location.port;
  const fingerPrint = Fingerprint2.x64hash128(values.join(port), 31)
  Vue.prototype.$browserId = fingerPrint;
  console.log("浏览器 ID: " + fingerPrint);
});


Vue.use(ElementUI);
Vue.use(VueCookies);
Vue.use(VueClipboard);
Vue.use(VueClipboards);
Vue.use(Contextmenu);
Vue.use(VCharts);
Vue.use(PiniaVuePlugin);
Vue.use(pinia);

Vue.prototype.$notify = Notification;
Vue.prototype.$axios = axios;
Vue.prototype.$useRoleAuths = useRoleAuths;
Vue.prototype.$useDeptAuths = useDeptAuths;
Vue.prototype.$cookies.config(60 * 30);
// 使用v-charts引入图表时报错：undefined (reading ‘map‘)
Vue._watchers = Vue.prototype._watchers = [];

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js